import React from 'react';
import { Card, CardHeader, CardBody, CardTitle } from "reactstrap";
import { useTranslation } from 'react-i18next';
import { chartExample3} from "../../variables/charts.js";
import { Bar } from "react-chartjs-2";

const EmailsHistogram = () => {
    const { t } = useTranslation();
    return (
        <Card className="card-chart">
            <CardHeader>
                <h5 className="card-category" style={{cursor:"default"}}>{t('Daily_Sales')}</h5>
                <CardTitle tag="h3" style={{cursor:"default"}}>
                    <i className="tim-icons icon-delivery-fast text-primary" />{" "}
                    3,500€
                </CardTitle>
            </CardHeader>
            <CardBody>
                <div className="chart-area">
                    <Bar data={chartExample3.data} options={chartExample3.options}/>
                </div>
            </CardBody>
        </Card>
    );
};

export default EmailsHistogram;